<hr class="separator d-none d-lg-block" />

<!-- MOBILE LAYOUT -->
@if (isMobile$ | async) {
    <div>
        @for (entry of otherTimeSheetEntries; track entry) {
            <div>
                <div
                    class="row mt-3 mb-4 align-items-start"
                    [ngClass]="{ 'alert alert-warning timesheet-entries': isOverlapping(entry) }"
                >
                    <!-- START DATE AND TIME -->
                    <div class="col-12">
                        <label class="col-form-label" translate="CONFIRMATION_TIMERECORDING_CONFIRM_DESC_START">
                        </label>
                    </div>
                    <div class="col-7">
                        <pace-date-field
                            [value]="toHtml5Date(entry.startDate)"
                            [disabled]="true"
                            [ariaLabel]="'CONFIRMATION_TIMERECORDING_CONFIRM_DESC_STARTDATE' | translate"
                        ></pace-date-field>
                    </div>
                    <div class="col-5">
                        <pace-time-field
                            [value]="toHtml5Time(entry.startTime)"
                            [disabled]="true"
                            [ariaLabel]="'CONFIRMATION_TIMERECORDING_CONFIRM_DESC_STARTTIME' | translate"
                        ></pace-time-field>
                    </div>
                    <!-- End Date and Time-->
                    <div class="col-12">
                        <label class="col-form-label" translate="CONFIRMATION_TIMERECORDING_CONFIRM_DESC_END"> </label>
                    </div>
                    <div class="col-7">
                        <pace-date-field
                            [value]="toHtml5Date(entry.endDate)"
                            [disabled]="true"
                            [ariaLabel]="'CONFIRMATION_TIMERECORDING_CONFIRM_DESC_END_DATE' | translate"
                        ></pace-date-field>
                    </div>
                    <div class="col col-lg-5">
                        <pace-time-field
                            [value]="toHtml5Time(entry.endTime)"
                            [disabled]="true"
                            [ariaLabel]="'CONFIRMATION_TIMERECORDING_CONFIRM_DESC_END_TIME' | translate"
                        ></pace-time-field>
                    </div>
                    <!-- Right hand block - Activity and Notification -->
                    <div class="col-12 mt-3">
                        <div class="row">
                            <div class="col-4 text-start">
                                <label
                                    class="col-form-label"
                                    translate="CONFIRMATION_TIMERECORDING_CONFIRM_DESC_ACTIVITY"
                                >
                                </label>
                            </div>
                            <label class="col no-call-outs col-form-label fw-normal text-start">{{
                                getDesc(entry)
                            }}</label>
                        </div>
                    </div>
                    <div class="col-12 mt-3">
                        <div class="row">
                            <div class="col-4 align-items-center justify-content-between">
                                <label
                                    class="col-form-label"
                                    translate="CONFIRMATION_TIMERECORDING_CONFIRM_DESC_NOTIFICATION"
                                >
                                </label>
                            </div>
                            <div class="col-8 align-items-center justify-content-between">
                                @if (entry.notificationId && entry.notificationId.qmNum) {
                                    <label class="no-call-outs col-form-label fw-normal text-start">
                                        {{ entry.notificationId.qmNum }} ({{ entry.notificationId.maNum }})
                                    </label>
                                } @else {
                                    <label
                                        class="no-call-outs col-form-label fw-normal text-start"
                                        [translate]="'CONFIRMATION_TIMERECORDING_MANUAL_TIMESHEET_ENTRY'"
                                    >
                                    </label>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                @if ($index < otherTimeSheetEntries.length - 1) {
                    <hr class="separator" />
                }
            </div>
        }
    </div>
} @else {
    <div class="row mb-3">
        <div class="col-1 limited-col-width"></div>
        <div class="col-6 ps-0">
            <label class="col-form-label">
                <span translate="CONFIRMATION_TIMERECORDING_CONFIRM_DESC_START"></span>
                <span class="px-1">/</span>
                <span translate="CONFIRMATION_TIMERECORDING_CONFIRM_DESC_END"></span>
            </label>
        </div>
        <div class="col-2">
            <label class="col-form-label" translate="CONFIRMATION_TIMERECORDING_OTHER_ACTIVITY"> </label>
        </div>
        <div class="col">
            <label class="col-form-label" translate="CONFIRMATION_TIMERECORDING_OTHER_NOTIFICATION"> </label>
        </div>
    </div>
    @for (entry of otherTimeSheetEntries; track entry) {
        <div>
            <div
                class="row mt-3 mb-4 align-items-start"
                [ngClass]="{ 'alert alert-warning timesheet-entries': isOverlapping(entry) }"
            >
                <div class="col-1 limited-col-width px-0"></div>
                <!-- Left hand block - date and time entries -->
                <div class="col-6">
                    <!-- START DATE AND TIME -->
                    <div class="row gap-2">
                        <div class="col-5 p-0">
                            <pace-date-field
                                [value]="toHtml5Date(entry.startDate)"
                                [disabled]="true"
                                [ariaLabel]="'CONFIRMATION_TIMERECORDING_CONFIRM_DESC_STARTDATE' | translate"
                            ></pace-date-field>
                        </div>
                        <div class="col-3 p-0">
                            <pace-time-field
                                [value]="toHtml5Time(entry.startTime)"
                                [disabled]="true"
                                [ariaLabel]="'CONFIRMATION_TIMERECORDING_CONFIRM_DESC_STARTTIME' | translate"
                            ></pace-time-field>
                        </div>
                    </div>
                    <!-- End Date and Time-->
                    <div class="row gap-2 mt-1">
                        <div class="col-5 p-0">
                            <pace-date-field
                                [value]="toHtml5Date(entry.endDate)"
                                [disabled]="true"
                                [ariaLabel]="'CONFIRMATION_TIMERECORDING_CONFIRM_DESC_END_DATE' | translate"
                            ></pace-date-field>
                        </div>
                        <div class="col-3 p-0">
                            <pace-time-field
                                [value]="toHtml5Time(entry.endTime)"
                                [disabled]="true"
                                [ariaLabel]="'CONFIRMATION_TIMERECORDING_CONFIRM_DESC_END_TIME' | translate"
                            ></pace-time-field>
                        </div>
                    </div>
                </div>
                <!-- Right hand block - Activity and Notification -->
                <div class="col-4">
                    <div class="row">
                        <div class="col-6 align-items-center justify-content-between">
                            <label class="no-call-outs col-form-label fw-normal text-start">{{ getDesc(entry) }}</label>
                        </div>
                        <div class="col-6 align-items-center justify-content-between">
                            @if (entry.notificationId && entry.notificationId.qmNum) {
                                <label class="no-call-outs col-form-label fw-normal text-start">
                                    {{ entry.notificationId.qmNum }} ({{ entry.notificationId.maNum }})
                                </label>
                            } @else {
                                <label
                                    class="no-call-outs col-form-label fw-normal text-start text-nowrap"
                                    [translate]="'CONFIRMATION_TIMERECORDING_MANUAL_TIMESHEET_ENTRY'"
                                >
                                </label>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
}
<!-- END OF MOBILE LAYOUT-->

<!-- DESKTOP LAYOUT -->
<!-- END OF DESKTOP LAYOUT-->
